"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARE_SCOPE = exports.Status = void 0;
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
const LoadingIndicator_1 = __importDefault(require("@atg/icf-react-components/components/LoadingIndicator"));
const react_1 = __importStar(require("react"));
const AsyncErrorComponent_1 = __importDefault(require("./Error/AsyncErrorComponent"));
const loadComponent_1 = require("./loadComponent");
const useDynamicScript_1 = require("./useDynamicScript");
const ErrorBoundary_1 = __importDefault(require("./Error/ErrorBoundary"));
const overrides_1 = require("./overrides");
var Status;
(function (Status) {
    Status[Status["Loading"] = 0] = "Loading";
    Status[Status["Error"] = 1] = "Error";
    Status[Status["Ready"] = 2] = "Ready";
})(Status = exports.Status || (exports.Status = {}));
exports.SHARE_SCOPE = "default";
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (typeof __federated_module_load_urls__ === "undefined") {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    globalThis.__federated_module_load_urls__ = {};
}
const FederatedModule = ({ scope, module, error = react_1.default.createElement(AsyncErrorComponent_1.default, null), fallback = react_1.default.createElement(LoadingIndicator_1.default, null), url, federatedModulesCdn, ...otherProps }) => {
    url = (0, overrides_1.checkOverrides)(scope, url);
    const status = (0, useDynamicScript_1.useDynamicScript)(scope, url, federatedModulesCdn.fallbackMappings);
    const [Component, setComponent] = (0, react_1.useState)(null);
    switch (status) {
        case Status.Loading:
            return react_1.default.createElement(react_1.default.Fragment, null, fallback);
        case Status.Error:
            return react_1.default.createElement(react_1.default.Fragment, null, error);
        case Status.Ready:
            // eslint-disable-next-line
            const loadedUrl = __federated_module_load_urls__[scope];
            // Hypothetical corner case where the script has loaded but the URL hasn't been set yet.
            if (!loadedUrl) {
                return react_1.default.createElement(react_1.default.Fragment, null, error);
            }
            if (Component === null) {
                setComponent((0, react_1.lazy)((0, loadComponent_1.loadComponent)(scope, module)));
            }
            // Slicing off the name of the JS file to get the path where it's served from.
            // eg. https://integ.streamate.icfcdn.com/legal/remoteEntry.js -> https://integ.streamate.icfcdn.com/legal/
            // eslint-disable-next-line
            const baseUrl = loadedUrl.split("/").slice(0, -1).join("/");
            return (react_1.default.createElement(react_1.Suspense, { fallback: fallback },
                react_1.default.createElement(ErrorBoundary_1.default, { boundaryName: scope + module, fallback: error }, Component !== null && (react_1.default.createElement(Component, { ...otherProps, baseUrl: baseUrl, federatedModules: federatedModulesCdn })))));
    }
};
exports.default = FederatedModule;
